import React,{useState} from "react";
import logo from "../assets/images/logo/bigmall-logo.png";
import { Link } from "react-router-dom";
import AppModal from "./AppModal";
const MobileBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleModalClose = () => {
      setIsModalOpen(false);
    };
    const handleModalOpen = () => {
        setIsModalOpen(true);
        };
  return (
    <div
      className="mobile-banner d-block d-md-none"
      style={{
        backgroundColor: "#ffeded",
        padding: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Logo placeholder */}
      <div className="d-flex align-items-center gap-5">
        <div className="max-w-120 ms-16">
          <Link to="/" className="link">
            <img src={logo} alt="Logo" />
          </Link>
        </div>
        {/* Banner text */}
        <div>
            <button className="btn" onClick={handleModalOpen}>
          <span className="badge bg-main-50 text-main-600">
            Get the Bigmall app to enjoy more benefits
          </span>
        </button>
        </div>
      </div>
        {/* Modal trigger */}
        {isModalOpen && <AppModal onClose={handleModalClose} /> }

    </div>
  );
};

export default MobileBanner;
